import { createContext, useContext, useEffect, useState } from "react";
import { api } from "../lib/api";
import { BRAND, STATES } from "../data/destinations";
import { PACKAGES, FAQS, WHY_RANDZ, GALLERY_IMAGES, INSTAGRAM_POSTS } from "../data/content";
import { ARTICLES, CATEGORIES } from "../data/articles";
import { DESTINATIONS } from "../data/destinations-detail";

const BACKEND = process.env.REACT_APP_BACKEND_URL;

export const resolveImg = (src) => (src && src.startsWith("/api/") ? `${BACKEND}${src}` : src);

const DEFAULTS = {
  brand: BRAND,
  heroImage: "https://images.unsplash.com/photo-1447958374760-1ce70cf11ee3?w=2400&q=85",
  states: STATES,
  destinations: DESTINATIONS,
  packages: PACKAGES.map((p, i) => ({ ...p, featured: i < 3, badge: "" })),
  articles: ARTICLES,
  categories: CATEGORIES,
  gallery: GALLERY_IMAGES.map((url, i) => ({ id: String(i), url, caption: "", order: i })),
  faqs: FAQS,
  why: WHY_RANDZ,
  instagram: INSTAGRAM_POSTS,
};

const SiteContext = createContext(DEFAULTS);

const hasValue = (v) => {
  if (v == null || v === "") return false;
  if (Array.isArray(v)) return v.length > 0;
  if (typeof v === "object") return Object.keys(v).length > 0;
  return true;
};

export function SiteProvider({ children }) {
  const [data, setData] = useState(DEFAULTS);

  useEffect(() => {
    api
      .get("/public/content")
      .then(({ data: d }) => {
        setData((prev) => ({
          ...prev,
          ...Object.fromEntries(Object.entries(d).filter(([, v]) => hasValue(v))),
        }));
      })
      .catch(() => {});
  }, []);

  return <SiteContext.Provider value={data}>{children}</SiteContext.Provider>;
}

export const useSite = () => useContext(SiteContext);
